module.exports = __webpack_public_path__ + "img/phone.c706ba33.svg";